import { render, staticRenderFns } from "./FiscaisListagemBotoesAcoes.vue?vue&type=template&id=ea4bc582"
import script from "./FiscaisListagemBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./FiscaisListagemBotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports